// Import commonly used flags
import {
	// All country flags (alphabetically ordered to avoid duplicates)
	AD,
	AE,
	AF,
	AG,
	AI,
	AL,
	AM,
	AO,
	AQ,
	AR,
	AS,
	AT,
	AU,
	AW,
	AX,
	AZ,
	BA,
	BB,
	BD,
	BE,
	BF,
	BG,
	BH,
	BI,
	BJ,
	BL,
	BM,
	BN,
	BO,
	BQ,
	BR,
	BS,
	BT,
	BV,
	BW,
	BY,
	BZ,
	CA,
	CC,
	CD,
	CF,
	CG,
	CH,
	CI,
	CK,
	CL,
	CM,
	CN,
	CO,
	CR,
	CU,
	CV,
	CW,
	CX,
	CY,
	CZ,
	DE,
	DJ,
	DK,
	DM,
	DO,
	DZ,
	EC,
	EE,
	EG,
	EH,
	ER,
	ES,
	ET,
	FI,
	FJ,
	FK,
	FM,
	FO,
	FR,
	GA,
	GB,
	GD,
	GE,
	GF,
	GG,
	GH,
	GI,
	GL,
	GM,
	GN,
	GP,
	GQ,
	GR,
	GS,
	GT,
	GU,
	GW,
	GY,
	HK,
	HM,
	HN,
	HR,
	HT,
	HU,
	ID,
	IE,
	IL,
	IM,
	IN,
	IO,
	IQ,
	IR,
	IS,
	IT,
	JE,
	JM,
	JO,
	JP,
	KE,
	KG,
	KH,
	KI,
	KM,
	KN,
	KP,
	KR,
	KW,
	KY,
	KZ,
	LA,
	LB,
	LC,
	LI,
	LK,
	LR,
	LS,
	LT,
	LU,
	LV,
	LY,
	MA,
	MC,
	MD,
	ME,
	MF,
	MG,
	MH,
	MK,
	ML,
	MM,
	MN,
	MO,
	MP,
	MQ,
	MR,
	MS,
	MT,
	MU,
	MV,
	MW,
	MX,
	MY,
	MZ,
	NA,
	NC,
	NE,
	NF,
	NG,
	NI,
	NL,
	NO,
	NP,
	NR,
	NU,
	NZ,
	OM,
	PA,
	PE,
	PF,
	PG,
	PH,
	PK,
	PL,
	PM,
	PN,
	PR,
	PS,
	PT,
	PW,
	PY,
	QA,
	RE,
	RO,
	RS,
	RU,
	RW,
	SA,
	SB,
	SC,
	SD,
	SE,
	SG,
	SH,
	SI,
	SJ,
	SK,
	SL,
	SM,
	SN,
	SO,
	SR,
	SS,
	ST,
	SV,
	SX,
	SY,
	SZ,
	TC,
	TD,
	TF,
	TG,
	TH,
	TJ,
	TK,
	TL,
	TM,
	TN,
	TO,
	TR,
	TT,
	TV,
	TW,
	TZ,
	UA,
	UG,
	UM,
	US,
	UY,
	UZ,
	VA,
	VC,
	VE,
	VG,
	VI,
	VN,
	VU,
	WF,
	WS,
	XK,
	YE,
	YT,
	ZA,
	ZM,
	ZW
} from 'country-flag-icons/react/3x2';

// Mapping from 3-letter codes to 2-letter codes (ISO 3166-1)
export const countryCodeMapping = {
	// Major countries
	'FRA': 'FR',
	'DEU': 'DE',
	'USA': 'US',
	'GBR': 'GB',
	'UK': 'GB',
	'ITA': 'IT',
	'ESP': 'ES',
	'RUS': 'RU',
	'CHN': 'CN',
	'JPN': 'JP',
	'CAN': 'CA',
	'AUS': 'AU',
	'BRA': 'BR',
	'IND': 'IN',
	'MEX': 'MX',
	'NLD': 'NL',
	'SWE': 'SE',
	'NOR': 'NO',
	'DNK': 'DK',
	'FIN': 'FI',
	'AUT': 'AT',
	'BEL': 'BE',
	'CHE': 'CH',
	'CZE': 'CZ',
	'HUN': 'HU',
	'POL': 'PL',
	'PRT': 'PT',
	'IRL': 'IE',
	'GRC': 'GR',
	'BGR': 'BG',
	'HRV': 'HR',
	'ROU': 'RO',
	'SVK': 'SK',
	'SVN': 'SI',
	'LVA': 'LV',
	'EST': 'EE',
	'LUX': 'LU',
	'MLT': 'MT',
	'CYP': 'CY',
	'ARG': 'AR',
	'CHL': 'CL',
	'COL': 'CO',
	'PER': 'PE',
	'VEN': 'VE',
	'URY': 'UY',
	'PRY': 'PY',
	'BOL': 'BO',
	'ECU': 'EC',
	'GUY': 'GY',
	'SUR': 'SR',
	'GUF': 'GF',
	'FLK': 'FK',
	'ZAF': 'ZA',
	'NGA': 'NG',
	'EGY': 'EG',
	'KEN': 'KE',
	'GHA': 'GH',
	'MAR': 'MA',
	'TUN': 'TN',
	'DZA': 'DZ',
	'LBY': 'LY',
	'SDN': 'SD',
	'ETH': 'ET',
	'UGA': 'UG',
	'TZA': 'TZ',
	'ZWE': 'ZW',
	'BWA': 'BW',
	'MOZ': 'MZ',
	'MDG': 'MG',
	'ZMB': 'ZM',
	'MWI': 'MW',
	'LSO': 'LS',
	'SWZ': 'SZ',
	'NAM': 'NA',
	'AGO': 'AO',
	'COD': 'CD',
	'CMR': 'CM',
	'CIV': 'CI',
	'SEN': 'SN',
	'MLI': 'ML',
	'BFA': 'BF',
	'NER': 'NE',
	'TCD': 'TD',
	'CAF': 'CF',
	'GAB': 'GA',
	'COG': 'CG',
	'STP': 'ST',
	'GNQ': 'GQ',
	'GNB': 'GW',
	'GIN': 'GN',
	'LBR': 'LR',
	'TGO': 'TG',
	'BEN': 'BJ',
	'CPV': 'CV',
	'SYC': 'SC',
	'MUS': 'MU',
	'COM': 'KM',
	'DJI': 'DJ',
	'SOM': 'SO',
	'ERI': 'ER',
	'SSD': 'SS',
	'UKR': 'UA',
	// Extended list (only codes not in Major countries section)
	'AND': 'AD',
	'ARE': 'AE',
	'AFG': 'AF',
	'ATG': 'AG',
	'AIA': 'AI',
	'ALB': 'AL',
	'ARM': 'AM',
	'ATA': 'AQ',
	'ASM': 'AS',
	'ABW': 'AW',
	'AZE': 'AZ',
	'BIH': 'BA',
	'BRB': 'BB',
	'BGD': 'BD',
	'BDI': 'BI',
	'BLM': 'BL',
	'BMU': 'BM',
	'BRN': 'BN',
	'BES': 'BQ',
	'BHS': 'BS',
	'BTN': 'BT',
	'BVT': 'BV',
	'BLR': 'BY',
	'BLZ': 'BZ',
	'CCK': 'CC',
	'COK': 'CK',
	'CRI': 'CR',
	'CUB': 'CU',
	'CUW': 'CW',
	'CXR': 'CX',
	'DMA': 'DM',
	'DOM': 'DO',
	'ESH': 'EH',
	'FJI': 'FJ',
	'FSM': 'FM',
	'FRO': 'FO',
	'GRD': 'GD',
	'GEO': 'GE',
	'GGY': 'GG',
	'GIB': 'GI',
	'GRL': 'GL',
	'GMB': 'GM',
	'GLP': 'GP',
	'SGS': 'GS',
	'GTM': 'GT',
	'GUM': 'GU',
	'HKG': 'HK',
	'HMD': 'HM',
	'HND': 'HN',
	'HTI': 'HT',
	'IDN': 'ID',
	'ISR': 'IL',
	'IMN': 'IM',
	'IOT': 'IO',
	'IRQ': 'IQ',
	'IRN': 'IR',
	'ISL': 'IS',
	'JEY': 'JE',
	'JAM': 'JM',
	'JOR': 'JO',
	'KGZ': 'KG',
	'KHM': 'KH',
	'KIR': 'KI',
	'KNA': 'KN',
	'PRK': 'KP',
	'KOR': 'KR',
	'KWT': 'KW',
	'CYM': 'KY',
	'KAZ': 'KZ',
	'LAO': 'LA',
	'LBN': 'LB',
	'LCA': 'LC',
	'LIE': 'LI',
	'LKA': 'LK',
	'LTU': 'LT',
	'MAF': 'MF',
	'MHL': 'MH',
	'MKD': 'MK',
	'MMR': 'MM',
	'MNG': 'MN',
	'MAC': 'MO',
	'MNP': 'MP',
	'MTQ': 'MQ',
	'MRT': 'MR',
	'MSR': 'MS',
	'MDV': 'MV',
	'MYS': 'MY',
	'NCL': 'NC',
	'NFK': 'NF',
	'NIC': 'NI',
	'NPL': 'NP',
	'NRU': 'NR',
	'NIU': 'NU',
	'NZL': 'NZ',
	'OMN': 'OM',
	'PAN': 'PA',
	'PYF': 'PF',
	'PNG': 'PG',
	'PHL': 'PH',
	'PAK': 'PK',
	'SPM': 'PM',
	'PCN': 'PN',
	'PRI': 'PR',
	'PSE': 'PS',
	'PLW': 'PW',
	'QAT': 'QA',
	'REU': 'RE',
	'SRB': 'RS',
	'RWA': 'RW',
	'SAU': 'SA',
	'SLB': 'SB',
	'SGP': 'SG',
	'SHN': 'SH',
	'SJM': 'SJ',
	'SLE': 'SL',
	'SMR': 'SM',
	'SXM': 'SX',
	'SYR': 'SY',
	'TCA': 'TC',
	'ATF': 'TF',
	'THA': 'TH',
	'TJK': 'TJ',
	'TKL': 'TK',
	'TLS': 'TL',
	'TKM': 'TM',
	'TON': 'TO',
	'TUR': 'TR',
	'TTO': 'TT',
	'TUV': 'TV',
	'TWN': 'TW',
	'UMI': 'UM',
	'UZB': 'UZ',
	'VAT': 'VA',
	'VCT': 'VC',
	'VGB': 'VG',
	'VIR': 'VI',
	'VNM': 'VN',
	'VUT': 'VU',
	'WLF': 'WF',
	'WSM': 'WS',
	'YEM': 'YE',
	'MYT': 'YT'
};

// Create a mapping of country codes to flag components
export const flagComponents = {
	// All country flags (alphabetically ordered)
	'AD': AD,
	'AE': AE,
	'AF': AF,
	'AG': AG,
	'AI': AI,
	'AL': AL,
	'AM': AM,
	'AO': AO,
	'AQ': AQ,
	'AR': AR,
	'AS': AS,
	'AT': AT,
	'AU': AU,
	'AW': AW,
	'AX': AX,
	'AZ': AZ,
	'BA': BA,
	'BB': BB,
	'BD': BD,
	'BE': BE,
	'BF': BF,
	'BG': BG,
	'BH': BH,
	'BI': BI,
	'BJ': BJ,
	'BL': BL,
	'BM': BM,
	'BN': BN,
	'BO': BO,
	'BQ': BQ,
	'BR': BR,
	'BS': BS,
	'BT': BT,
	'BV': BV,
	'BW': BW,
	'BY': BY,
	'BZ': BZ,
	'CA': CA,
	'CC': CC,
	'CD': CD,
	'CF': CF,
	'CG': CG,
	'CH': CH,
	'CI': CI,
	'CK': CK,
	'CL': CL,
	'CM': CM,
	'CN': CN,
	'CO': CO,
	'CR': CR,
	'CU': CU,
	'CV': CV,
	'CW': CW,
	'CX': CX,
	'CY': CY,
	'CZ': CZ,
	'DE': DE,
	'DJ': DJ,
	'DK': DK,
	'DM': DM,
	'DO': DO,
	'DZ': DZ,
	'EC': EC,
	'EE': EE,
	'EG': EG,
	'EH': EH,
	'ER': ER,
	'ES': ES,
	'ET': ET,
	'FI': FI,
	'FJ': FJ,
	'FK': FK,
	'FM': FM,
	'FO': FO,
	'FR': FR,
	'GA': GA,
	'GB': GB,
	'GD': GD,
	'GE': GE,
	'GF': GF,
	'GG': GG,
	'GH': GH,
	'GI': GI,
	'GL': GL,
	'GM': GM,
	'GN': GN,
	'GP': GP,
	'GQ': GQ,
	'GR': GR,
	'GS': GS,
	'GT': GT,
	'GU': GU,
	'GW': GW,
	'GY': GY,
	'HK': HK,
	'HM': HM,
	'HN': HN,
	'HR': HR,
	'HT': HT,
	'HU': HU,
	'ID': ID,
	'IE': IE,
	'IL': IL,
	'IM': IM,
	'IN': IN,
	'IO': IO,
	'IQ': IQ,
	'IR': IR,
	'IS': IS,
	'IT': IT,
	'JE': JE,
	'JM': JM,
	'JO': JO,
	'JP': JP,
	'KE': KE,
	'KG': KG,
	'KH': KH,
	'KI': KI,
	'KM': KM,
	'KN': KN,
	'KP': KP,
	'KR': KR,
	'KW': KW,
	'KY': KY,
	'KZ': KZ,
	'LA': LA,
	'LB': LB,
	'LC': LC,
	'LI': LI,
	'LK': LK,
	'LR': LR,
	'LS': LS,
	'LT': LT,
	'LU': LU,
	'LV': LV,
	'LY': LY,
	'MA': MA,
	'MC': MC,
	'MD': MD,
	'ME': ME,
	'MF': MF,
	'MG': MG,
	'MH': MH,
	'MK': MK,
	'ML': ML,
	'MM': MM,
	'MN': MN,
	'MO': MO,
	'MP': MP,
	'MQ': MQ,
	'MR': MR,
	'MS': MS,
	'MT': MT,
	'MU': MU,
	'MV': MV,
	'MW': MW,
	'MX': MX,
	'MY': MY,
	'MZ': MZ,
	'NA': NA,
	'NC': NC,
	'NE': NE,
	'NF': NF,
	'NG': NG,
	'NI': NI,
	'NL': NL,
	'NO': NO,
	'NP': NP,
	'NR': NR,
	'NU': NU,
	'NZ': NZ,
	'OM': OM,
	'PA': PA,
	'PE': PE,
	'PF': PF,
	'PG': PG,
	'PH': PH,
	'PK': PK,
	'PL': PL,
	'PM': PM,
	'PN': PN,
	'PR': PR,
	'PS': PS,
	'PT': PT,
	'PW': PW,
	'PY': PY,
	'QA': QA,
	'RE': RE,
	'RO': RO,
	'RS': RS,
	'RU': RU,
	'RW': RW,
	'SA': SA,
	'SB': SB,
	'SC': SC,
	'SD': SD,
	'SE': SE,
	'SG': SG,
	'SH': SH,
	'SI': SI,
	'SJ': SJ,
	'SK': SK,
	'SL': SL,
	'SM': SM,
	'SN': SN,
	'SO': SO,
	'SR': SR,
	'SS': SS,
	'ST': ST,
	'SV': SV,
	'SX': SX,
	'SY': SY,
	'SZ': SZ,
	'TC': TC,
	'TD': TD,
	'TF': TF,
	'TG': TG,
	'TH': TH,
	'TJ': TJ,
	'TK': TK,
	'TL': TL,
	'TM': TM,
	'TN': TN,
	'TO': TO,
	'TR': TR,
	'TT': TT,
	'TV': TV,
	'TW': TW,
	'TZ': TZ,
	'UA': UA,
	'UG': UG,
	'UM': UM,
	'US': US,
	'UY': UY,
	'UZ': UZ,
	'VA': VA,
	'VC': VC,
	'VE': VE,
	'VG': VG,
	'VI': VI,
	'VN': VN,
	'VU': VU,
	'WF': WF,
	'WS': WS,
	'XK': XK,
	'YE': YE,
	'YT': YT,
	'ZA': ZA,
	'ZM': ZM,
	'ZW': ZW
};

